/* eslint-disable camelcase */
/* eslint-disable max-len  */
import request from './utils'

const oldBackendURL = 'https://backend.upskill.com.bd/api'
// const oldBackendURLv2 = "https://be.upskill.com.bd/api";
// const BackendURL = "http://localhost:9000";
const BackendURL = 'https://service.upskill.com.bd'
const MobileBackendURL = 'http://157.245.99.120:9001'
// const blogs = "https://blog.upskill.com.bd/wp-json/wp/v2/posts?_embed";

// const CourseURL = "http://localhost:9001"
const CourseURL = 'https://service4.upskill.com.bd'
// const TrainerURL = "http://localhost:9004/trainer"

const TrainerURL = 'http://13.228.161.254:9004/trainer'
const AuthURL = 'https://auth.upskill.com.bd'
const AuthSocial = {
  url: `${AuthURL}/login`,
}
const Trainer = {
  upload: `${TrainerURL}/upload`,
  workshop_request: `${TrainerURL}/workshop-request/`,
  workshop_requests: `${TrainerURL}/workshop-requests/`,
}
const oldBackend = {
  tokenToUser: `${oldBackendURL}/user`,
  workshops: `${oldBackendURL}/workshops`,
  workshop: (id) => `${oldBackendURL}/workshops/${id}`,
  loginUser: `${oldBackendURL}/login`,
  registerUser: `${oldBackendURL}/register`,
  status: (id) => `${oldBackendURL}/workshop/${id}/status`,
  join: (id) => `${oldBackendURL}/workshop/${id}/join`,
  cancel: (id) => `${oldBackendURL}/workshop/${id}/cancel`,
  registeredFor: `${oldBackendURL}/registrants_id`,
  validate: `${oldBackendURL}/validate`,
  newsletter: `${oldBackendURL}/newsletter`,
  changePassword: `${oldBackendURL}/password_reset`,
}

const Backend = {
  registerUser: `${BackendURL}/public/user_register`,
  trainerDashboard: `${BackendURL}/public/trainer/dashboard`,
  getCourses: `${BackendURL}/public/courses`,
  updateCourse: `${BackendURL}/public/course_update`,
  registerConsultant: `${BackendURL}/public/consultant`,
  vault: `${BackendURL}/public/vault`,
  authors: `${BackendURL}/public/authors`,
  fp_request: `${BackendURL}/public/forget_password_request`,
  login_consultant: `${BackendURL}/public/consultant/login`,
  can_promo: `${BackendURL}/public/pstate`,
}

const FP = {
  initial: `${BackendURL}/public/forget_password_request`,
  checkToken: `${BackendURL}/public/forget_password`,
  final: `${BackendURL}/public/pwd_request`,
}

const Mobile = {
  upload: `${MobileBackendURL}/upload`,
  domains: `${MobileBackendURL}/domains`,
  subdomains: (id) => `${MobileBackendURL}/subdomains/${id}`,
  topics: (id) => `${MobileBackendURL}/topics/${id}`,
  tests: (id) => `${MobileBackendURL}/tests/${id}`,
  root: `${MobileBackendURL}/root`,
}

// const chatAPI = "localhost:5000"
const chatAPI = 'service7.upskill.com.bd'
const Courses = {
  courses: `${CourseURL}/courses`,
  purchaseSubscription: `${CourseURL}/user/purchase/subscription`,
  purchaseWorkshop: (wid) => `${CourseURL}/user/purchase/workshop/${wid}`,
  validatePurchase: (id) => `${CourseURL}/purchase/status/${id}/`,
  workshopPurchaseStatus: (id) => `${CourseURL}/status/workshop/${id}/`,
  resourcesWorkshop: `${CourseURL}/status/resources`,
  billing: `${CourseURL}/billing`,
  update_billing: `${CourseURL}/update_billing`,
  join: (id) => `${CourseURL}/workshop/${id}/join`,
}
const ClassURL = 'https://be.upskill.com.bd'
const ClassBackend = {
  getClassesByWID: (wid) => `${ClassURL}/api/classes/${wid}`,
}
export default new (function Upskill() {
  this.getClassesByWID = (wid) => request.get(ClassBackend.getClassesByWID(wid))
  this.socialLink = () => AuthSocial.url
  this.social = (token) =>
    request.get(AuthSocial.url, {}, { headers: { Authorization: token } })
  this.trainerUpload = Trainer.upload
  this.addWR = (body) =>
    request.post(Trainer.workshop_request, body, {
      headers: { 'X-Auth-Secret': localStorage.getItem('ctoken') },
    })
  this.getWR = () =>
    request.get(
      Trainer.workshop_requests,
      {},
      { headers: { 'X-Auth-Secret': localStorage.getItem('ctoken') } }
    )
  this.base = BackendURL
  this.wsURL = oldBackend.workshops
  this.workshop = (id) => request.get(oldBackend.workshop(id))
  this.workshops = () => request.get(oldBackend.workshops)
  this.tokenToUser = () => request.get(oldBackend.tokenToUser)
  this.getCourses = () => request.get(Backend.getCourses)
  this.getCoursesPremium = () => request.get(Courses.courses)

  this.getBilling = () => request.get(Courses.billing)
  this.addBilling = (body) => request.post(Courses.billing, body)
  this.updateBilling = (body) => request.post(Courses.update_billing, body)

  this.getCoursesPremiumID = (id) => request.get(Courses.courses + '/' + id)
  ;(this.purchaseSubscription = (body) =>
    request.post(Courses.purchaseSubscription, body)),
    (this.purchaseWorkshop = (wid, body) =>
      request.post(Courses.purchaseWorkshop(wid), body)),
    (this.validatePurchase = (id) => request.get(Courses.validatePurchase(id)))
  this.loginUser = (body) => request.post(oldBackend.loginUser, body)
  this.passwordChange = (body) => request.post(oldBackend.changePassword, body)
  this.workshop = (id) => request.get(oldBackend.workshops + '/' + id)
  this.status = (wid) => request.get(`${oldBackend.status(wid)}`)
  this.join = (wid) => request.get(`${Courses.join(wid)}`)
  this.cancel = (wid) => request.get(`${oldBackend.cancel(wid)}`)
  this.registeredFor = () => request.get(oldBackend.registeredFor)
  this.registerUser = (body) => request.postNoHeader(Backend.registerUser, body)
  this.oldRegister = (body) =>
    request.postNoHeader(oldBackend.registerUser, body)
  this.validate = (body) => request.postNoHeader(oldBackend.validate, body)
  this.updateCourse = (body) => request.post(Backend.updateCourse, body)
  this.subscribe = (body) => request.post(oldBackend.newsletter, body)
  this.vault = (body) => request.post(Backend.vault, body)
  this.authors = () => request.get(Backend.authors)
  this.trainerDashboard = () => request.get(Backend.trainerDashboard)
  this.fp_request = (body) => request.post(Backend.fp_request, body)
  this.registerConsultant = (body) =>
    request.post(Backend.registerConsultant, body, {
      headers: { 'X-Auth-Secret': body.password },
    })
  0
  this.loginConsultant = (body) => request.post(Backend.login_consultant, body)
  this.pwInit = (email) => request.post(FP.initial, { email: email })
  this.pwCheck = (id) => request.post(FP.checkToken, { id: id })
  this.pwFinal = (id, password) =>
    request.post(FP.final, { request_id: id, password: password })
  // this.blogs = () => request.getNoHeader(blogs);
  this.blogs = () => request.getNoHeader('https://blogs.upskill.com.bd/blogs')
  this.blog = (id) =>
    request.getNoHeader('https://blogs.upskill.com.bd/blogs/' + id)
  this.appDomains = () => request.get(Mobile.domains)
  this.appSubdomains = (id) => request.get(Mobile.subdomains(id))
  this.appTopics = (id) => request.get(Mobile.topics(id))

  this.discountByWid = (id) =>
    request.get(`${BackendURL}/public/discount/${id}`)
  this.discounts = () => request.get(`${BackendURL}/public/discounts`)
  this.userProfileStatus = () =>
    request.get(`${BackendURL}/public/user_profile`)
  this.userProfileCert = (body) =>
    request.post(`${BackendURL}/public/user_certificate`, body)

  this.userProfilePay = (wid) => request.get('http://localhost:8010', { wid })

  this.workshopPurchaseStatus = (wid) =>
    request.get(Courses.workshopPurchaseStatus(wid))
  this.resources = (id) =>
    request.get(Courses.resourcesWorkshop + '/' + id + '/')

  this.canPromo = () => request.get(Backend.can_promo)
  this.chat = (id) =>
    request.get(`https://${chatAPI}/channel/${String(id)}/messages`)
  this.chatws = (id) => `wss://${chatAPI}/channel/${String(id)}/ws`
  this.chatUpload = `https://${chatAPI}/upload`
})()
